import React, { useRef } from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./index.css";

const PrevArrow = ({ onClick }) => (
  <button className="nav-arrow-btn" onClick={onClick} aria-label="Previous">
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 70 70" fill="none">
      <circle cx="35" cy="35" r="35" transform="matrix(-1 0 0 1 70 0)" fill="#FF541C" />
      <path d="M50.6875 18.9585L38.98 32.1933C37.2562 34.142 37.3149 37.0871 39.1151 38.9656L50.6875 51.0416" stroke="white" strokeWidth="5" />
      <path d="M34.0547 18.9585L22.3472 32.1933C20.6234 34.142 20.6821 37.0871 22.4822 38.9656L34.0547 51.0416" stroke="white" strokeWidth="5" />
    </svg>
  </button>
);

const NextArrow = ({ onClick }) => (
  <button className="nav-arrow-btn" onClick={onClick} aria-label="Next">
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 70 70" fill="none">
      <circle cx="35" cy="35" r="35" fill="#FF541C" />
      <path d="M19.3047 17.9585L31.0121 31.1933C32.736 33.142 32.6773 36.0871 30.8771 37.9656L19.3047 50.0416" stroke="white" strokeWidth="5" />
      <path d="M35.9375 17.9585L47.645 31.1933C49.3688 33.142 49.3101 36.0871 47.5099 37.9656L35.9375 50.0416" stroke="white" strokeWidth="5" />
    </svg>
  </button>
);

const NbrCarousel = ({ data }) => {
  const swiperRef = useRef(null);
  const imgPath = process.env.REACT_APP_IMAGES;

  if (!data?.images?.length) return null;

  return (
    <section className="nbr-carousel-section section-spacing">
      <Container>
        <div
          className="nbr-carousel-wrapper"
          onMouseEnter={() => swiperRef.current?.autoplay?.stop()}
          onMouseLeave={() => swiperRef.current?.autoplay?.start()}
        >
          <Swiper
            modules={[Autoplay]}
            onSwiper={(s) => (swiperRef.current = s)}
            slidesPerView={1.1}
            spaceBetween={16}
            loop={true}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            breakpoints={{
              768: { slidesPerView: 3, spaceBetween: 20 },
              992: { slidesPerView: 4, spaceBetween: 24 },
            }}
          >
            {data.images.map((img, i) => (
              <SwiperSlide key={i}>
                <img src={`${imgPath}${img}`} alt="" className="nbr-carousel-img" loading="lazy" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="nbr-carousel-arrows">
          <PrevArrow onClick={() => swiperRef.current?.slidePrev()} />
          <NextArrow onClick={() => swiperRef.current?.slideNext()} />
        </div>
      </Container>
    </section>
  );
};

export default NbrCarousel;
